import { isNumber } from "src/components/js/statics1";

export class keikkaEval_returnMessage {
  constructor(expression) {
    this.success = false; // success is true if there was no error
    this.result = {
      bool: null, // bool is the result of the expression if it is a boolean
      num: null, // num is the result of the expression if it is a number
      string: expression, // string is the expression that was evaluated
      isEvaluated: false, // isEvaluated is true if the expression was evaluated by this constructor
    };
    this.error = {
      isError: false, // isError is true if there was an error
      message: "", // message is the error message or the result message
    };
    this.expression = expression; // expression is the expression that was evaluated
    this.expressionType = {
      isNull: false, // isNull is true if expression is null, undefined, or an empty string
      isBool: false, // isBool is true if expression is a boolean
      isNum: false, // isNum is true if expression is a number
      isString: false, // isString is true if expression is a string
      isEval: false, // isEval is true if expression contains { or }
    };
    this.resultType = {
      isBool: false, // isBool is true if result is a boolean
      isNum: false, // isNum is true if result is a number
      isString: false, // isString is true if result is a string
      isObject: false, // isObject is true if result is an object
    };

    try {
      // if no expression
      if (
        expression === null ||
        expression === undefined ||
        expression === "" ||
        expression === "null" ||
        expression === "undefined"
      ) {
        this.resultType.isString = true;
        this.resultType.isBool = true;
        this.success = true;
        this.result.string = "";
        this.result.bool = true;
        this.result.isEvaluated = true;
        this.error.isError = false;
        this.error.message = "NoError: Expression is null, undefined, or an empty string.";
        this.expressionType.isNull = true;
        this.expressionType.isString = true;
        this.expressionType.isBool = true;
      }

      // if expression is true or false or "true" or "false"
      else if (expression === true || expression === false) {
        this.success = true;
        this.result.bool = expression;
        this.result.isEvaluated = true;
        this.error.message = "NoError: Expression is a true or false.";
        this.expressionType.isBool = true;
      }
      // if expression is a string of true or false
      else if (expression === "true" || expression === "false") {
        this.success = true;
        this.result.bool = expression === "true" ? true : false;
        this.result.isEvaluated = true;
        this.error.message = "NoError: Expression is a true, false, or a string of true or false.";
        this.expressionType.isBool = true;
      }

      // if expression is number, return number
      if (
        expression &&
        expression.length > 0 &&
        (isNumber(expression) || isNumber(expression?.replace(",", ".")))
      ) {
        expression = expression.replace(",", ".");
        this.expression = expression;
        this.success = true;
        this.resultType.isNum = true;
        this.resultType.isBool = true;
        this.result.num = expression;
        this.result.isEvaluated = true;
        this.result.bool = expression > 0;
        this.error.message = "NoError: Expression is a number.";
        this.expressionType.isNum = true;
      }

      // if expressiosn is a string
      else if (typeof expression === "string" || expression instanceof String) {
        this.success = true;
        this.result.string = expression.trim();
        this.result.isEvaluated = true;
        this.expression = this.result.string;
        this.expressionType.isString = true;
        if (expression.includes("{")) {
          this.expressionType.isEval = true;
          this.error.message = "isEval: Expression contains { or }.";
        } else {
          this.error.message = "NoError: Expression is a string.";
        }
        // count number of { and }
        if (this.expressionType.isEval) {
          let count = 0;
          for (let i = 0; i < expression.length; i++) {
            if (expression[i] === "{") count++;
            if (expression[i] === "}") count--;
          }
          if (count !== 0) {
            this.error.isError = true;
            this.error.message = "Virhe: Kaarisulkuja ei ole suljettu oikein.";
          }
        }
      }
    } catch (error) {
      this.success = false;
      this.result.isEvaluated = true;
      this.error.isError = true;
      this.error.message = error.message;
    }
  }
}
